module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp1_9016.d989addf.png";